export type Category = 'EATS' | 'WALKS' | 'AREAS'

export interface Recommendation {
  id: number
  name: string
  category: Category
  neighborhood: string
  description: string
  lat: number
  lng: number
}

export const CATEGORY_CONFIG: Record<
  Category,
  { color: string; bg: string; label: string }
> = {
  EATS: { color: '#ea580c', bg: '#ffedd5', label: 'Eats' }, // soft orange/terracotta
  WALKS: { color: '#0d9488', bg: '#ccfbf1', label: 'Walks' }, // soft teal
  AREAS: { color: '#3b82f6', bg: '#dbeafe', label: 'Areas' }, // soft blue
}

export const recommendations: Recommendation[] = [
  {
    id: 1,
    name: 'ByWard Market',
    category: 'AREAS',
    neighborhood: 'Lower Town',
    description:
      "Where you'll get a bunch of shops, proximity to Parliament Hill, close to the National Art Gallery and Notre-Dame Cathedral — a must imo.",
    lat: 45.4275,
    lng: -75.693,
  },
  {
    id: 2,
    name: 'The Glebe',
    category: 'AREAS',
    neighborhood: 'The Glebe',
    description:
      'Loads of restaurants and shops all walkable in one straight line.',
    lat: 45.395,
    lng: -75.689,
  },
  {
    id: 3,
    name: 'Chinatown',
    category: 'AREAS',
    neighborhood: 'Centretown',
    description:
      'If you want pho or any cheap and cheerful food, this is the area.',
    lat: 45.41,
    lng: -75.705,
  },
  {
    id: 4,
    name: 'Rideau Hall',
    category: 'WALKS',
    neighborhood: 'New Edinburgh',
    description:
      "Probably not on many lists but it's a beautiful walk among this public park. Only open during sunlight hours.",
    lat: 45.444,
    lng: -75.686,
  },
  {
    id: 5,
    name: 'Rockcliffe Park',
    category: 'WALKS',
    neighborhood: 'Rockcliffe',
    description:
      'Really nice walk amongst the trees — feels like a mini hike without going too far from the city.',
    lat: 45.45,
    lng: -75.68,
  },
  {
    id: 6,
    name: 'Westboro',
    category: 'AREAS',
    neighborhood: 'Westboro',
    description:
      "Nice shops and restaurants. Probably not worth the trek if you don't have a car though.",
    lat: 45.393,
    lng: -75.753,
  },
  {
    id: 7,
    name: "Dow's Lake",
    category: 'WALKS',
    neighborhood: 'Old Ottawa South',
    description:
      "Really peaceful by the water with nice restaurants right on it. I'd only venture out here on a nice day — there's really only restaurants here.",
    lat: 45.396,
    lng: -75.705,
  },
  {
    id: 8,
    name: 'Little Victories — Elgin',
    category: 'EATS',
    neighborhood: 'Centretown',
    description:
      'Best coffee in the city. This is their flagship location on Elgin.',
    lat: 45.417,
    lng: -75.688,
  },
  {
    id: 9,
    name: 'Little Italy',
    category: 'AREAS',
    neighborhood: 'Little Italy',
    description:
      'Restaurants and pubs like Pub Italia that are cheap and cheerful, or $$$ spots like Perch that are really good too.',
    lat: 45.406,
    lng: -75.72,
  },
  {
    id: 10,
    name: 'Supply and Demand',
    category: 'EATS',
    neighborhood: 'Westboro',
    description:
      'If you do make it out to Westboro — probably my favourite restaurant in the city.',
    lat: 45.3933,
    lng: -75.7543,
  },
  {
    id: 11,
    name: 'Buvette Daphnée',
    category: 'EATS',
    neighborhood: 'ByWard Market',
    description:
      "Great restaurant, very conveniently located in the market. Might have to make resos — it's not huge.",
    lat: 45.428,
    lng: -75.692,
  },
  {
    id: 12,
    name: 'Little Victories — Hintonburg',
    category: 'EATS',
    neighborhood: 'Hintonburg',
    description: 'Another location close to some vinyl shops.',
    lat: 45.398,
    lng: -75.732,
  },
  {
    id: 13,
    name: 'Suzy Q Donuts',
    category: 'EATS',
    neighborhood: 'Wellington West',
    description:
      "An Ottawa staple. This one's near cute shops on your way to Westboro.",
    lat: 45.396,
    lng: -75.735,
  },
  {
    id: 14,
    name: 'Black Squirrel Books',
    category: 'AREAS',
    neighborhood: 'Centretown',
    description:
      'My fav used bookstore in the city. Near House of Targ too — known for its perogies and arcade games.',
    lat: 45.4,
    lng: -75.71,
  },
  {
    id: 15,
    name: 'Hintonburg',
    category: 'AREAS',
    neighborhood: 'Hintonburg',
    description:
      "Easier to get to than I originally thought — take the light rail to Tunney's or Bayview and walk south.",
    lat: 45.397,
    lng: -75.735,
  },
]
